import { green, orange, red } from '@material-ui/core/colors';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import classNames from 'classnames';
import { SquareCircle as ChangedIcon, MinusBoxOutline as RemoveIcon, PlusBoxOutline as AddIcon } from 'mdi-material-ui';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    fileIcon: {
      fontSize: '1rem'
    },
    changedIcon: {
      color: orange[500]
    },
    addedIcon: {
      color: green[500]
    },
    removedIcon: {
      color: red[500]
    }
  })
);

interface Props {
  diffType: string;
  className?: string;
}

function FileIcon(props: Props) {
  const { diffType, className } = props;
  const classes = useStyles({});

  let icon;
  switch (diffType) {
    case 'changed':
      icon = <ChangedIcon className={classNames(classes.fileIcon, classes.changedIcon, className)} color="inherit" />;
      break;
    case 'added':
      icon = <AddIcon className={classNames(classes.fileIcon, classes.addedIcon, className)} color="inherit" />;
      break;
    case 'removed':
      icon = <RemoveIcon className={classNames(classes.fileIcon, classes.removedIcon, className)} color="inherit" />;
      break;
  }

  return icon;
};

export default FileIcon;
